import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'

import { TooltipModule } from 'primeng/tooltip'

@Component({
  selector: 'flx-branch-merge-state',
  imports: [CommonModule, TooltipModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div
      [ngClass]="mergeInProgress() ? 'bg-orange-50 text-orange-500' : 'bg-green-50 text-green-500'"
      [pTooltip]="tooltipMessage()"
      class="flex items-center gap-1 text-xs font-semibold rounded-2xl py-px px-2 w-fit max-w-full"
      tooltipPosition="bottom"
      tooltipStyleClass="text-xs"
    >
      @if (mergeInProgress()) {
        <i class="ph ph-warning"></i>
        Merge conflict
      } @else {
        <i class="ph ph-arrows-merge"></i>
        <span class="whitespace-nowrap">merged from</span>
        <span class="truncate max-w-[20ch]">{{ guardedBranchName() }}</span>
        @if (isMergedBranchArchived()) {
          <i class="ph ph-archive text-neutral-400"></i>
        }
      }
    </div>
  `,
})
export class BranchMergeStateComponent {
  mergeInProgress = input(false)
  mergedFromBranchName = input.required<string | undefined>()
  isMergedBranchArchived = input(false)
  guardedBranchName = computed(() => {
    const branchName = this.mergedFromBranchName()
    return branchName?.includes('#') ? branchName.split('#')[0] : branchName
  })

  tooltipMessage = computed(() => {
    const mergeInProgress = this.mergeInProgress()
    const branchName = this.guardedBranchName()
    const isMergedBranchArchived = this.isMergedBranchArchived()
    if (mergeInProgress) {
      return null
    }
    return `This version was created by a merge from ${branchName ?? 'an unknown branch'}${isMergedBranchArchived ? ', which is now archived' : ''}`
  })
}
